"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var UploadField = /** @class */ (function (_super) {
    __extends(UploadField, _super);
    function UploadField() {
        var _this = _super.call(this) || this;
        _this.state = {};
        return _this;
    }
    UploadField.prototype.render = function () {
        var _this = this;
        var hover = this.state.hover;
        var _a = this.props, children = _a.children, uploadProps = _a.uploadProps, containerProps = _a.containerProps, onFiles = _a.onFiles, onChange = _a.onChange;
        var handleHover = typeof children === 'function';
        return (react_1.default.createElement("div", __assign({ style: styles.container }, containerProps, { onMouseEnter: function () { return (handleHover ? _this.setState({ hover: true }) : null); }, onMouseLeave: function () { return (handleHover ? _this.setState({ hover: false }) : null); } }),
            handleHover ? children(hover) : children,
            react_1.default.createElement("input", __assign({ type: "file", style: styles.input, title: '', key: Math.random(), onChange: function (e) {
                    if (e.target.files && onFiles)
                        onFiles(e.target.files);
                    if (onChange)
                        onChange(e);
                } }, uploadProps))));
    };
    return UploadField;
}(react_1.default.Component));
exports.default = UploadField;
var styles = {
    container: {
        overflow: 'hidden',
        position: 'relative',
    },
    input: {
        top: 0,
        right: 0,
        opacity: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        position: 'absolute',
    },
};
//# sourceMappingURL=upload-field.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/libs/navjobs-upload/upload-field.js
// module id = 2561
// module chunks = 0